<mat-action-list>
  <ellipse-main-nav-menu-item *ngFor="let item of menuItems" [menuItem]="item"/>
</mat-action-list>
